import { httpClient } from '@/services/http/httpClient'

export type SendVideoToUserParams = {
  videoId: number
  description: string
  notificationToUsersIds: string[]
}

export async function sendVideoToUser({
  videoId,
  description,
  notificationToUsersIds,
}: SendVideoToUserParams) {
  return await httpClient.post('events/v2/send-event-notification-video', {
    videoId,
    description,
    notificationToUsersIds,
  })
}
